import { render, staticRenderFns } from "./KindEditor.vue?vue&type=template&id=57044bd4&"
import script from "./KindEditor.vue?vue&type=script&lang=js&"
export * from "./KindEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports